export default __webpack_public_path__ + "static/fung-76bada799de6718c70da91087da6eb96.jpg";